import { createElement } from 'react';
import { render } from 'react-dom';
import SiteBadge from '../components/SiteBadge';

export const install = (props) => {
  const root = document.createElement('div');
  document.body.appendChild(root);

  render(
    createElement(SiteBadge, props),
    root,
  );
};
